import { render, staticRenderFns } from "./ClientRecords.vue?vue&type=template&id=ba133994&scoped=true"
import script from "./ClientRecords.vue?vue&type=script&lang=js"
export * from "./ClientRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba133994",
  null
  
)

export default component.exports